import React from 'react';
import ProfileStatsBlock from './ProfileStatsBlock';

// Helpers
import statAlgorithm from '../../utils/StatAlgorithm'


const allStatCategories = (games) => (
  games.reduce((list, game) => list.concat(game.player_stats), [])
)

const allStatCategoryNames = (games) => (
  allStatCategories(games).map(cat => cat.name)
)

const seasonUniqueStatCategoryNames = (games) => (
  Array.from(new Set(allStatCategoryNames(games)))
)

const toFields = (categories) => categories.map(cat => cat.fields)

const statNames = (category) => category.fields.map(f => f.name)

const aggregateFields = (categories, categoryName, sportName) => (
  statNames(categories[0]).map(statName => aggregate(toFields(categories), sportName, categoryName, statName))
)

const aggregate = (fieldSets, sportName, categoryName, statName) => {
  const fieldsToAggregate = fieldSets.map(fieldSet =>
    fieldSet.find(field => field.name === statName)
  )

  const values = fieldsToAggregate.map(field => field.value)

  return {
    ...fieldsToAggregate[0],
    value: String(statAlgorithm(sportName, categoryName, statName)(values, fieldSets))
  }
}

const seasonAggregatStats = (categoryName, games, sportName) => {
  const toAggregate = allStatCategories(games).filter(cat => cat.name === categoryName)

  return {
    name: categoryName,
    fields: aggregateFields(toAggregate, categoryName, sportName)
  }
}

const ProfileSeasonOverallStats = ({ games, sport }) => (
  <div className="profile-stats-row">
    {
      seasonUniqueStatCategoryNames(games).map((categoryName, i) => (
        <ProfileStatsBlock {...seasonAggregatStats(categoryName, games, sport.name)} key={i} />)
      )
    }
  </div>
)

export default ProfileSeasonOverallStats



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileSeasonOverallStats.js